<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="3"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="3" defaultSel="2"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">
                <el-table :data="listData" style="width: 100%" class="bmo_tab">
                    <el-table-column prop="createTime" label="发布时间"></el-table-column>
                    <el-table-column prop="merchantName" label="发布商家"></el-table-column>
                    <el-table-column prop="description" label="文本"></el-table-column>
                    <el-table-column label="相册" width="400">
                        <template slot-scope="scope">
                            <div class="tab_row">
                                <img v-for="(item, index) in JSON.parse(scope.row.photo)" :key="index" class="tab_img"
                                    :src="item">
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status">
                                <span class="li_clo1" v-if="scope.row.status == 1">已通过</span>
                                <span class="li_clo2" v-if="scope.row.status == 2">未通过</span>
                            </p>
                            <el-button v-else type="text" @click="delectQx(scope.row)">审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <el-dialog title="审核" :visible.sync="dialog" width="30%">
            <div class="order_input1">
                <template>
                    <el-radio v-model="status" label="1">通过</el-radio>
                    <el-radio v-model="status" label="2">拒绝</el-radio>
                </template>
            </div>
            <!-- <div v-if="status == 1">
                <el-radio v-model="reco" label="0">不推荐</el-radio>
                <el-radio v-model="reco" label="1">推荐内容</el-radio>
            </div>
            <div v-if="status == 2">
                <el-radio v-model="isFreeze" label="0">不冻结权限</el-radio>
                <el-radio v-model="isFreeze" label="1">冻结权限</el-radio>
            </div> -->
            <span slot="footer" class="dialog_footer">
                <el-button type="primary" @click="sendApi">确认</el-button>
                <el-button @click="dialog = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>

var util = require("@/common/util.js");
import { API_HUXLIST, API_SHHUIXU } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: '',
            dialog: false,
            status: '1',  // 1通过，2拒绝
            reco: '0',  // 0不推，1推荐
            isFreeze: '0', // 0不冻结，1推荐

            discountsMsgId: '',
            merchantId: ''
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
            let params = {}
            util.getData(API_HUXLIST, params, (res) => {
                this.listData = res.data.data
            })
        },
        delectQx(e) {
            console.log(e)
            this.discountsMsgId = e.discountsMsgId
            this.merchantId = e.merchantId
            this.dialog = true
        },
        sendApi() {  // 添加权限
            let params = new URLSearchParams();

            params.append('discountsMsgId', this.discountsMsgId);
            params.append('merchantId', this.merchantId);
            params.append('status', this.status);
            // if (this.status == 1) {
            //     params.append('reco', this.reco);
            // } else {
            //     params.append('isFreeze', this.isFreeze);
            // }
            util.getData(API_SHHUIXU, params, (res) => {
                console.log(res.data)
                this.dialog = false
                this.$message('操作成功')
                this.getListData()
            })
        },

        backAcount() {
            this.$confirm('确定退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                localStorage.removeItem("token");
                this.$router.push({ path: '/' });
                this.$message({
                    showClose: true,
                    message: '操作成功',
                    type: 'success'
                });
            }).catch(() => {
                console.log('已取消')
            })
        }
    }
}
</script>
  
<style lang="less">
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}

.g-header-right {
    background-color: #5c6be8;
    color: #FFF;
    padding-right: 40px;
    height: 60px;
    line-height: 60px;
    text-align: right;
}

.g-header-right span {
    margin: 0 10px;
    cursor: pointer;
}

.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.nav_search {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 30px;

    .nav_search_row {
        display: flex;
        flex-direction: row;
    }

    .nav_search_li {
        margin-right: 20px;
        width: 260px;
    }
}

.order_input1 {
    margin-bottom: 20px;
}

.bmo_tab {
    .tab_row {
        display: flex;
        flex-direction: row;
        // flex-wrap: wrap;
    }

    .tab_img {
        width: 60px;
        height: 60px;
        border-radius: 6px;
        background-color: #f2f2f2;
        margin-right: 12px;
    }

    .li_clo1 {
        color: #67c23a;
    }

    .li_clo2 {
        color: #f56c6c;
    }
}</style>


// WEBPACK FOOTER //
// src/pages/hxOne/index.vue